module.exports = __webpack_public_path__ + "static/media/row-of-students.bec7a75c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/row-of-students.jpg
 ** module id = 511
 ** module chunks = 0
 **/